<template>
  <Modal :id="'cpm-add-track-list-modal'" @cancelled="onCancel">
    <template slot="header">{{$t('add_track')}}</template>

    <template slot="body">
      <!-- <span>c{{ existing }} p{{ new }}</span> -->
      <div class="contact-type-selection">
        <div class="contact-type">
          <input
            type="radio"
            :checked="trackType == 'new'"
            @change="(e) => onChangeContactType('new')"
            value="new"
            name="contact"
          />
          <label for="contact" @click="(e) => onChangeContactType('new')"
            >{{$t('add_new_track')}}</label
          >
        </div>
        <div class="contact-type">
          <input
            type="radio"
            :checked="trackType == 'existing'"
            @change="(e) => onChangeContactType('existing')"
            value="existing"
            name="contact"
          />
          <label for="contact" @click="(e) => onChangeContactType('existing')"
            >{{$t('add_existing_track')}}</label
          >
        </div>
      </div>
      <div v-if="trackType == 'new'" class="fform-group">
        <div>
          <TextField
            class="m1"
            :id="'artist'"
            required
            v-bind="textFieldConfig"
            :value="artist"
            :placeholder="$t('artist')"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation"
          ></TextField>
          <TextField
            class="m1"
            :id="'title'"
            required
            v-bind="textFieldConfig"
            :value="title"
            :placeholder="$t('title')"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation"
          ></TextField>
          <TextField
            class="m1"
            :id="'version'"
            v-bind="textFieldConfig2"
            :value="version"
            :placeholder="$t('version')"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation"
          ></TextField>
          <TextField
            class="m1"
            :id="'playtime'"
            v-bind="textFieldConfig2"
            :value="playtime"
            :placeholder="$t('playtime')"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation"
          ></TextField>
          <TextField
            class="m1"
            :id="'isrc'"
            v-bind="textFieldConfig2"
            :value="isrc"
            :placeholder="$t('isrc')"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation"
          ></TextField>

          <Dropdown
            :options="rightsTV"
            class="group-input m2"
            :key="'group_dropdown_company'"
            :placeholder="$t('digital_rights')"
            :selected="rightsTV.find((e) => e.value == digitalRightType)"
            v-on:selectedChange="(e) => onFormatChange(e)"
            box
            :listHeight="250"
          ></Dropdown>

          <DTCheckbox
            :id="'barcode_catalog_error'"
            :label="$t('bonus')"
            :checked="bonus_track_flag == 1"
            @click="onBonusCheck"
            :minH="'42px'"
            :class="'ml0'"
          />
        </div>
      </div>
      <div v-if="trackType == 'existing'" class="fform-group">
        <SearchList
          :id="'trackList'"
          ref="venueSearchList"
          :items="trackList"
          :keyProperty="'track_id'"
          :label="$t('title')"
          :selectionNumber="'single'"
          @searched="searchTrack"
        >
          <template v-slot:item="{ item }">
            <tr class="dt-table2--row">
              <dt
                class="dt-table2--column"
                style="border-right: 1px solid #fefefe;flex:2"
              >
                <div class="ut-flex">
                  <div style="flex: 0.1" class="checkbox-container">
                    <div class="dt-checkbox v2 s1">
                      <input
                        type="checkbox"
                        name="name"
                        @click="(e) => onCheckboxChange(e, 'name', item)"
                      />
                      <div class="checkmark"></div>
                    </div>
                  </div>
                  <div style="flex: 0.9" class="txtov"> {{ getConcatTitle(item) }}</div>
                </div>
              </dt>
              <dt class="dt-table2--column" style="padding-left: 10px;flex:1">
                <span class="txtov">{{ item.artist }}</span>
              </dt>
            </tr>
          </template>
        </SearchList>
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">{{$t('cancel')}}</button>
      <button
        v-if="trackType == 'existing'"
        class="dt-button v1"
        @click.stop="addNewTrack"
        :class="{ disabled: !isExistingFormValid }"
        :disabled="!isExistingFormValid"
      >
        {{$t('ok')}}
      </button>
      <button
        v-if="trackType == 'new'"
        class="dt-button v1"
        :class="{ disabled: !isFormValid }"
        :disabled="!isFormValid"
        @click.stop="addNewTrack"
      >
        {{$t('ok')}}
      </button>
    </template>
  </Modal>
</template>

<script>
import { createValidator } from "@plugins/text-field";

import Modal from "@/dt-plugins/modal/modal";
import { tv } from "../../../../models/text-value.model";
import { releaseService } from "../../services/releases/releases.services";
import { ProductsService } from "../../services/products.service";

import SearchList from "@dtplugins/search-list/search-list";
import { addRemoveSet } from "../../../../utility";
import DTCheckbox from "../../../../plugins/checkbox/checkbox";

import { subscribeSubject } from "@/utility";
import { Subject } from "rxjs";
export default {
  components: {
    Modal,
    SearchList,
    DTCheckbox,
  },
  props: {},
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        immediateValidation: true,
      },

      textFieldConfig2: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        immediateValidation: false,
      },

      loading: true,
      formats: [],
      relatedProducts: [],
      relatedProductId: 0,
      formatId: 16,
      enteredCatalogNo: "",
      validationResult: {},
      trackList: [],
      digitalRightType: "",
      artists: "",
      title: "",
      version: "",
      artist: "",
      playtime: "",
      isrc: "",
      trackType: "new",
      bonus_track_flag: 0,
      selectedTracks: new Set(),

      searchString: "",
      trackSubject$: new Subject(),
      trackSearchResult:[],
    };
  },
  mounted: async function () {
    //   type operation = Boolean | 'toggle';

    const resData = await ProductsService.unrelatedTracks(this.external_id);
    console.log("RES DATA", resData);
    this.trackList = resData.data.tracks;
    this.relatedProducts = resData.data.related_products;


      subscribeSubject(this, this.trackSubject$, searchString => {

        ProductsService.searchUnrelatedTracks(this.external_id,searchString).then(res=>{
            console.log("SEARCH RESULT",searchString,res)
            this.trackList = res.data.tracks
        });
        
      })
  },
  computed: {
    external_id: function () {
      return this.$route.query.external_id;
    },
    rightsTV: function () {
      return [
        { text: "Full Rights", value: "1" },
        { text: "Bundle Only", value: "2" },
        { text: "No Digital Rights", value: "3" },
      ];
    },

    isFormValid: function () {
      console.log({ "this.validationResult": this.validationResult });
      return Object.values(this.validationResult).every((e) => e.valid);
    },
    isExistingFormValid: function () {
      return this.selectedTracks.size > 0;
    },
    trackArray:function(){
      return this.searchString.length>0?this.trackSearchResult:this.trackList;
    }
  },
  methods: {
    getConcatTitle:function(item){
      if(item.version && item.version.length>0){
        return `${item['title']} (${item['version']})`;
      }

      return item['title']||'';
    },
    onCheckboxChange: function (event, name, item) {
      const value = event.target.checked;
      this.selectedTracks = addRemoveSet(
        event.target.checked,
        this.selectedTracks,
        item.track_id
      );
      console.log("WWWW", item.track_id, value);
    },
    onChangeContactType: function (type) {
      this.trackType = type;

      this.$emit('changeWidth',type)
    },
    onValidation: function (name, value) {
      this.$set(this.validationResult, name, value);
      console.log(this.validationResult);
    },
    onTextFieldValueChange: function (key, value) {
      console.log("KEY,VALUE", key, value);
      this[key] = value;
    },

    onCancel: function () {
      this.$emit("cancelled", true);
    },

    addNewTrack: function (e) {
      console.log(
        "WERE",
        Array.from(this.selectedTracks).join(","),
        this.selectedTracks
      );
      let payload = {};
      if (this.trackType == "existing") {
        payload = {
          product_id: this.external_id,
          track_list: Array.from(this.selectedTracks).join(","),
          name: "existing",
        };
      } else {
        payload = {
          name: "new",
          product_id: this.external_id,
          title: this.title,
          version: this.version,
          artist: this.artist,
          playtime: this.playtime,
          isrc: this.isrc,
          digital_right_type: this.digitalRightType,
        };
      }

      this.$emit("create", payload);
    },
    onRadioChange: function (item) {
      console.log("TYPE", item);
      this.formatId = item.format_id;
    },
    onFormatChange: function (value) {
      console.log("VALUE", value);
      this.digitalRightType = value.value;
    },
    onBonusCheck: function (event) {
      if (event.target.checked) {
        this.bonus_track_flag = 1;
      } else {
        this.bonus_track_flag = 0;
      }
    },
    searchTrack: function (searchString) {
      this.searchString = searchString;
      console.log(this.searchString, searchString);
      this.trackSubject$.next(this.searchString);
    },

    //MARK: Methods
  },
};

const createPerson = ({
  firstName = "",
  lastName = "",
  email = "",
  phone = "",
  group = [],
} = {}) => {
  return {
    firstName,
    lastName,
    email,
    phone,
    group,
  };
};

const createCompany = ({
  companyName = "",
  city = "",
  country = "",
  group = [],
} = {}) => {
  return {
    companyName,
    city,
    country,
    group,
  };
};
</script>

<style lang="scss">
.cpm-add-track-list-modal {
  .form-group {
    display: flex;
    flex-direction: column;

    // .dt-input-box--container {
    //   flex: 1;
    //   margin: 5px 0px;
    //   margin-left: 0px;
    // }
    .ut-flex {
      .checkbox-container {
        flex: 0.1;
      }

      .txtov {
        flex: 0.9;
      }
    }
    .group-input {
      // margin-top: 25px;
      // margin-bottom: 10px;
      // margin-right: 5px;

      min-height: 42px;
    }
  }

  .new-controls,
  .existing-controls {
    height: 249px;
  }

  .contact-type-selection {
    display: flex;
    flex-direction: column;
    padding: 0px;
    margin-bottom: 10px;
    .contact-type {
      flex: 1;
      display: flex;
      margin: 4px 0px;

      input {
        margin: auto 0;
      }
      label {
        margin-left: 10px;
        cursor: pointer;
      }
    }
  }

  .dt-modal--options {
    display: flex;
    justify-content: flex-end;
    button {
      min-width:138px;
      max-width:138px;
      flex: 1;
      &:first-child {
        margin-right: 10px;
      }
      &:last-child {
        margin-left: 10px;
      }
    }
  }

  .search-row {
    display: flex;
    &.chbx-row {
      .search--input-c {
        padding: 0px 5px;
      }
    }
    .search--input {
      flex: 1;
      max-width: 394px;
    }
    .search--checkbox {
      min-width: 20px;

      // padding-top: 15px;
      margin-left: 4px;

      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }
}
</style>
